export const DEFAULT_SAVE_TIMEOUT = 0;
